<template>
  <div class="imgbox">
    <img class="vipinfosbgsj" src="../../assets/img/vipinfosbgsj.png" alt="" />

    <div v-if="type == 1" @click="ljxf" class="ljxf">立即续费</div>
    <div class="viphqqx">
      <img class="vipqx" src="../../assets/img/vipiconqx.png" alt="" />
      会员期限
    </div>
    <div class="vipExpireTime">
      <div style="margin-bottom: 6px;">
        盯盘提醒：<span :class="userinfo && isExpire(userinfo.vipExpireTime) ? 'expire' : ''">{{
          formatDateTimeRT(userinfo.vipExpireTime) || '暂未开通'
        }}</span>

        <img
          v-if="userinfo && isExpire(userinfo.vipExpireTime)"
          class="isexpire"
          src="../../assets/img/exprieIcon.png"
          alt=""
        />
      </div>
      <div>
        发帖助手：<span
          :class="createPostInfos && isExpire(createPostInfos.validityTime) ? 'expire' : ''"
          >{{
            (createPostInfos && formatDateTimeRT(createPostInfos.validityTime)) || '暂未开通'
          }}</span
        >
        <img
          v-if="createPostInfos && isExpire(createPostInfos.validityTime)"
          class="isexpire"
          src="../../assets/img/exprieIcon.png"
          alt=""
        />
      </div>
    </div>
    <div class="tiptitle">
      {{
        userinfo.vipExpireTime || createPostInfos ? '' : '暂未开通,'
      }}VIP会员尊享一尘盯盘发贴自动提醒、手机发帖一键上图
    </div>
  </div>
</template>
<script>
import { formatDateTimeRT } from '@/utils/index';
export default {
  props: ['userinfo', 'createPostInfos', 'type'],
  data() {
    return {};
  },
  computed: {},
  methods: {
    formatDateTimeRT,
    isExpire(date) {
      if (!date) {
        return false;
      }
      let now = new Date().getTime() / 1000;
      console.log(now);
      console.log(now < new Date(date).getTime() / 1000);

      return !(now < new Date(date).getTime() / 1000);
    },
    ljxf() {
      this.$router.push('/vip');
    },
  },
};
</script>
<style lang="less" scoped>
.imgbox {
  position: relative;
  font-size: 12px;
  color: #2e3337;
  padding: 12px 16px 14px 16px;
  box-sizing: border-box;
  //   background: linear-gradient(135.68deg, rgba(243, 245, 245, 1) 0%, rgba(201, 229, 255, 1) 100%);
  //   box-shadow: 0px 19px 20px -16px rgba(45, 140, 252, 0.5), 1px 1px 0px rgba(97, 170, 255, 1),
  //     -1px -1px 0px rgba(255, 255, 255, 1);
  border-radius: 14px;
  background: url('../../assets/img/vipinfosbg.png') no-repeat;
  background-size: 100% 100%;
  .vipinfosbgsj {
    position: absolute;
    right: 13px;
    width: 121px;
    height: 84px;
    top: -8px;
  }
  .viphqqx {
    padding-top: 12px;
    background: rgba(242, 249, 255, 1);
    border: 0.5px solid rgba(45, 126, 219, 1);
    border-radius: 4px;
    padding: 3px 6px;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 12px;
    img.vipqx {
      width: 13px;
      height: 14px;
    }
  }
  .vipExpireTime {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 18px;
    margin-bottom: 21px;
    color: rgba(24, 110, 188, 1);
    text-align: left;
    .expire {
      color: rgba(166, 166, 166, 1);
      text-decoration: line-through;
    }
    .isexpire {
      width: 40px;
      // height: 16px;
      margin-left: 6px;
    }
  }
  .tiptitle {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 18px;
    color: rgba(121, 72, 234, 1);
    padding-bottom: 27px;
  }
  .ljxf {
    position: absolute;
    right: 11px;
    top: 67px;
    border-radius: 13px;
    background: linear-gradient(90deg, rgba(237, 110, 160, 1) 0%, rgba(236, 140, 105, 1) 100%);
    font-size: 12px;
    font-weight: 500;
    padding: 4px 11px;
    color: rgba(255, 235, 59, 1);
  }
}
</style>
<style lang="less">
body.pc-mode .imgbox {
  padding: 22px 24px 20px;
  border-radius: 22px;
  box-shadow: 0 18px 36px rgba(29, 67, 108, 0.1);
}

body.pc-mode .imgbox .vipinfosbgsj {
  right: 18px;
  top: -4px;
  width: 150px;
  height: auto;
}

body.pc-mode .imgbox .viphqqx {
  margin-bottom: 14px;
  padding: 6px 10px;
  border-radius: 999px;
}

body.pc-mode .imgbox .vipExpireTime {
  margin-bottom: 16px;
  font-size: 13px;
  line-height: 1.9;
}

body.pc-mode .imgbox .tiptitle {
  padding-bottom: 8px;
  font-size: 13px;
  line-height: 1.8;
}

body.pc-mode .imgbox .ljxf {
  top: 24px;
  right: 24px;
  padding: 7px 14px;
  border-radius: 999px;
  font-weight: 600;
  box-shadow: 0 10px 24px rgba(236, 140, 105, 0.18);
}
</style>
